import { render, staticRenderFns } from "./trainingModuleFormBuilder.vue?vue&type=template&id=a2269a4e&scoped=true&"
import script from "./trainingModuleFormBuilder.vue?vue&type=script&lang=js&"
export * from "./trainingModuleFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./trainingModuleFormBuilder.vue?vue&type=style&index=0&id=a2269a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2269a4e",
  null
  
)

export default component.exports